import { createSelector } from 'reselect'

import { selectSectionSettingsState } from './selectSectionSettingsState'

export const selectSectionSettingsStatus = createSelector(
  [selectSectionSettingsState],
  ({ status }) => status
)
